import { LOADER_HANDLER_TYPES, METHOD_TYPES } from 'utils/constants/index'
import axiosInstance, { microServices } from 'network/apis'

export const getCustomGameReportService = (data) => {
  return axiosInstance(METHOD_TYPES.get, '/report/pl-custom-report', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.table,
    params: data
  })
}

export const getCasinoGameReportService = (data) => {
  return axiosInstance(METHOD_TYPES.get, '/report/pl-casino-report', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.table,
    params: data
  })
}

export const getSportsBookGameReportService = (data) => {
  return axiosInstance(METHOD_TYPES.get, '/report/pl-sportsbook-report', {}, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.table,
    params: data
  })
}

export const getSqlReportData = (data) => {
  return axiosInstance(METHOD_TYPES.post, '/report/report-by-query', {
    query: data
  }, {
    server: microServices.USER_URL,
    loader: LOADER_HANDLER_TYPES.table
  })
}
